module.exports = __webpack_public_path__ + "static/media/02-hand-thumbs-up-like.5834676c.png";